import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as i, openBlock as n, normalizeClass as d, createElementVNode as o } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconCornerUpLeft",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ o("path", {
  d: "M8 4a2.5 2.5 0 0 1 2.5 2.5V10a.5.5 0 0 1-1 0V6.5A1.5 1.5 0 0 0 8 5H3.207l1.647 1.646a.5.5 0 1 1-.708.708l-2.5-2.5a.5.5 0 0 1 0-.708l2.5-2.5a.5.5 0 1 1 .708.708L3.207 4H8Z",
  fill: "currentColor"
}, null, -1), m = [
  _
];
function f(e, u, r, p, h, a) {
  return n(), i("svg", {
    "aria-label": r.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--corner-up-left"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Corner Up Left",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const I = /* @__PURE__ */ l(s, [["render", f]]);
export {
  I as default
};
//# sourceMappingURL=corner-up-left.js.map
